import React from "react";

const Banner = ({text="Banner text"}) => {
  return (
    <div className="banner-container">
      <p className="banner-text">
        {text}
      </p>
    </div>
  );
};

export default Banner;
